import(/* webpackMode: "eager" */ "D:\\workSpace\\abt\\webui-nextjs\\app\\global-error.tsx");
